export default __webpack_public_path__ + "static/media/regulatory--end-of-low-beam-headlights--g1.91c69fc1.png";